import 'core-js/features/string/includes';
import 'core-js/features/array/includes';
import 'core-js/features/array/find';

import React, { Component, Fragment } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { isIE } from 'react-device-detect';

import './app.scss';

import store from './redux';
import { Home, Categories, Studios, Rentals, Technicians, AboutUs, Cafe, TermsAndConditions } from './pages';
import { FetchWrapper, DetectInViewWrapper } from './helpers';
import { Content } from './containers';
import { Header, ContactForm, CategoryList, Footer, Preloader, LocationToggle } from './components';
import CookiesUsagePopup from './containers/Content/CookiesUsagePopup';

class App extends Component {
  componentDidMount = () => {
    if (isIE) {
      document.body.classList.add('isIE');
    }
  };

  render() {
    return (
      <DetectInViewWrapper>
        <Provider store={store}>
          <FetchWrapper>
            <Router>
              <Fragment>
                <Preloader />
                <Header />
                <div className="wrapper">
                  <Content>
                    <Switch>
                      <Route exact path="/" component={Home} />
                      <Route exact path="/categories" component={Categories} />
                      <Route exact path="/studios" component={Studios} />
                      <Route path="/studios/:internalName" component={Studios} />
                      <Route exact path="/rentals" component={Rentals} />
                      <Route path="/rentals/:subcategory" component={CategoryList} />
                      <Route path="/technicians" component={Technicians} />
                      <Route path="/about-us" component={AboutUs} />
                      <Route path="/cafe" component={Cafe} />
                      <Route path="/forms-and-policies" component={TermsAndConditions} />
                    </Switch>
                  </Content>
                  <Footer />
                </div>
                <ContactForm />
                <LocationToggle />
                <CookiesUsagePopup />
              </Fragment>
            </Router>
          </FetchWrapper>
        </Provider>
      </DetectInViewWrapper>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js